import type { User } from '../../../api/types';

export function getChatEnabled(user: User | null | undefined): boolean {
  if (!user) {return false;}
  if (user.user_role === 'ADMIN' || user.user_role === 'OPS') {return true;}
  return Boolean(user.feature_flags?.chat_enabled);
}
